document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-faq-toggle]');
  if (toggle) {
    const item = toggle.closest('.faq-item');
    const open = item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  const navToggle = event.target.closest('[data-nav-toggle]');
  if (navToggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav.classList.toggle('is-open');
    navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  const productThumb = event.target.closest('[data-product-thumb]');
  if (productThumb) {
    const gallery = productThumb.closest('[data-product-gallery]');
    const mainImage = gallery && gallery.querySelector('[data-product-main] img');
    if (mainImage && productThumb.dataset.imageSrc) {
      mainImage.src = productThumb.dataset.imageSrc;
      mainImage.srcset = '';
      gallery.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        thumb.classList.remove('is-active');
      });
      productThumb.classList.add('is-active');
    }
  }
});

document.addEventListener('change', function (event) {
  const variantSelect = event.target.closest('[data-product-variant]');
  if (variantSelect) {
    const root = variantSelect.closest('[data-product-root]');
    const option = variantSelect.options[variantSelect.selectedIndex];
    const price = root && root.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  }
});
